/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * Toolbar for application.
 */
import React, { Component } from 'react';
import IconButton from 'material-ui/IconButton';
import { connect } from 'react-redux';
import Menu from 'material-ui/svg-icons/navigation/menu';
import Avatar from 'material-ui/Avatar';
import { Toolbar, ToolbarGroup, ToolbarSeparator } from 'material-ui/Toolbar';
import { Dialog } from 'material-ui';
import { EditableInlineV2 } from '../../components/text';
import FlatButton from 'material-ui/FlatButton';
import Version from 'material-ui/svg-icons/action/info-outline';
import * as actions from '../../containers/users/actions';
import { Logout as LogoutModal } from '../../modals';
import {
    getPagePermissions,
    hasCreatePermission,
    CUSTOMERS_PERMISSION,
    TABULAR_PRICES_PERMISSION
} from '../../security/permissions';
import {
    users as users
} from '../../services';
import { SnackBar } from '../../components/widgets';

const customContentStyle = {
    width: '40%',
    maxWidth: 'none',
};

const user = { userId: "", roster: "", password: "", name: "", email: "", role: "" };
var image = new Image();

class CustomToolbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            onOpenPerfilModal: false,
            user: { ...user },
            newPassword: "",
            confirmLogoutOpen: false,
            editionActiveOnName: false,
            editionActiveOnPassword: false
        };
    }

    handleChange(event, key, value) {
        const form = { [key]: value };

        var reader = new FileReader();
        reader.readAsDataURL(form.roster[0]);
        reader.onload = function (f) {
            this.setState({ user: { ...this.state.user, roster: reader.result } })
        }.bind(this);
    }

    componentDidMount(userInformation) {
        this._isMounted = true;
        users.getUsers({
            id: this.props.userData.userId
        }).then(data => {
            if (this._isMounted) {
                this.setState({ user: { ...data[0] } });
                this.setState({ originalUser: { ...data[0] } });
            }
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        var showRole = '';
        image.src = this.state.user.roster;
        const { confirmLogoutOpen, editionActiveOnName, editionActiveOnPassword } = this.state;
        switch (this.state.user.role) {
            case 'ROLE_EXECUTIVE': showRole = "Ejecutivo";
                break;
            case 'ROLE_DOCUMENT_SUPPORTER': showRole = "Documentador";
                break;
            case 'ROLE_ADMIN': showRole = "Administrador";
                break;
            case 'ROLE_OPERATIVE': showRole = "Operativo";
                break;
            case 'ROLE_FINANCES': showRole = "Finanzas";
                break;
            default:
                break;
        };

        const { globalData: { snackbarConfig } } = this.props;

        const actions = [
            <FlatButton
                label="Cancelar"
                onClick={() => {
                    this.setState({ onOpenPerfilModal: false });
                    this.componentDidMount(this.props.userData.userId);
                    this.setState({ newPassword: '', editionActiveOnName: false, editionActiveOnPassword: false });
                }}
            />,
            <FlatButton
                label="Guardar"
                onClick={() => {
                    this.props.editUserPasswordRoster(this.state);
                    this.setState({ onOpenPerfilModal: false });
                    this.setState({ newPassword: '', editionActiveOnName: false, editionActiveOnPassword: false });
                }}
                primary
            />
        ];

        return (
            <div className="toolbarNavigation">
                <Toolbar className="toolbarNavigation-background">
                    <ToolbarGroup firstChild style={{ marginLeft: '-4px' }}>
                        <a href="" data-toggle="modal" data-target="#versioninfo">
                            <Version color="#FFF" viewBox="0 -2 24 24" />
                        </a>
                        <img
                            style={{ width: 160 }}
                            role="presentation"
                            src="images/logo-title-light.png"
                        />
                    </ToolbarGroup>
                    <ToolbarGroup>
                        <div className="dropdown">
                            <button className="btn btn-empty dropdown-toggle" type="button" data-toggle="dropdown">
                                <Avatar src={this.state.user.roster === "" ? "images/uxceo-128.jpg" : image.src} />
                                <div className="hidden-sm-down text-left" style={{ marginLeft: 10 }}>
                                    <span style={{ fontWeight: '600' }}>{this.state.user.name}</span><br />
                                    <span>{showRole}</span>
                                </div>
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                    <a
                                        href=""
                                        onClick={(event) => {
                                            event.preventDefault();
                                            this.setState({ onOpenPerfilModal: true });
                                        }}
                                    >
                                        Ver Perfil
                                    </a>
                                </li>
                                <li className="divider" href="" />
                                <li>
                                    <a
                                        href=""
                                        onClick={(event) => {
                                            event.preventDefault();
                                            this.setState({ confirmLogoutOpen: true });
                                        }}
                                    >
                                        Cerrar Sesion
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <ToolbarSeparator style={{ backgroundColor: '#d0d0d0' }} />
                        <IconButton tooltip="Abrir Menu" onTouchTap={() => $('#modalNavigation').modal()}>
                            <Menu />
                        </IconButton>
                    </ToolbarGroup>
                    <div className="modal fade modal-version" id="versioninfo" tabIndex="-1" role="dialog" aria-labelledby="versioninfo" aria-hidden="true">
                        <div className="modal">
                            <div className="modal__container">
                                <div className="modal__header hidden-md-up">
                                    <img src="images/ssf_logo_version_header_left.png" style={{ height: '9rem' }} />
                                    <img src="images/ssf_logo_version_header_right.png" style={{ height: '9rem' }} />
                                </div>
                                <div className="modal__featured hidden-sm-down">
                                    <div className="modal__circle"></div>
                                    <img src="images/ssf_logo_version.png" className="modal__product" />
                                </div>
                                <div className="modal__content">
                                    <h2 className="no-margins" style={{ color: '#4e4e4e' }}>Información de la aplicación</h2>
                                    <p>Aplicación desarrollada por <a href="http://www.sicom.mx/" target="_blank">Sicom</a> y <a href="http://ssf.com.mx/" target="_blank">Smart Software Factory</a> 2017</p>
                                    <hr className="margin-top-1 margin-bottom-1" />
                                    <p>- Versión de aplicación <strong>1.0.12</strong></p>
                                    <p>- Versión de API<strong> 1.0.11-RELEASE</strong></p>
                                    <p>- Fecha de generación de la versión <strong>24/01/2018</strong></p>
                                    <hr className="margin-top-1 margin-bottom-1" />
                                    <div className="text-right">
                                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <Dialog
                        className="modalstyle"
                        open={this.state.onOpenPerfilModal}
                        autoScrollBodyContent
                        contentStyle={{ width: "30rem" }}
                        onRequestClose={() => this.setState({ onOpenPerfilModal: false })}
                        actions={actions}
                    >
                        <div>
                            <div className="display-flex-just-center">
                                <div className="image-upload">
                                    <label htmlFor="image-input" style={{ cursor: 'pointer' }}>
                                        <Avatar
                                            size={200}
                                            src={this.state.user.roster === "" ? "images/uxceo-128.jpg" : image.src} />
                                    </label>
                                    <input
                                        id="image-input"
                                        style={{ display: 'none' }}
                                        type="file"
                                        accept="image/x-png,image/gif,image/jpeg"
                                        onChange={(event) => {
                                            this.handleChange(event, 'roster', event.target.files);
                                        }}
                                    />
                                </div>

                            </div>

                            <div className="col-md-12 text-left margin-top-2" style={{ marginLeft: 10 }}>
                                <p className="text-bold text-color-light">Nombre Completo (editable)</p>
                                <EditableInlineV2
                                    type="text"
                                    value={this.state.user.name}
                                    editViewActive={editionActiveOnName}
                                    onlyNotify
                                    onDoubleClick={() => this.setState({ editionActiveOnName: true })}
                                    notify={(value) => {
                                        this.setState({ user: { ...this.state.user, name: value } });
                                    }}
                                />
                                <p className="text-bold text-color-light">Cargo</p>
                                <EditableInlineV2
                                    type="text"
                                    value={showRole}
                                    editViewActive={false}
                                /*notify={(value) => {
                                    this.updateCustomsClearence('mawbMbl', value);
                                }}*/
                                />
                                <p className="text-bold text-color-light">Correo Electronico</p>
                                <EditableInlineV2
                                    type="text"
                                    value={this.state.user.email}
                                    editViewActive={false}
                                /*notify={(value) => {
                                    this.updateCustomsClearence('mawbMbl', value);
                                }}*/
                                />
                                <p className="text-bold text-color-light">Contraseña (editable)</p>
                                <EditableInlineV2
                                    type="password"
                                    value={this.state.newPassword}
                                    editViewActive={editionActiveOnPassword}
                                    onlyNotify
                                    onDoubleClick={() => this.setState({ editionActiveOnPassword: true })}
                                    notify={(value) => {
                                        this.setState({ newPassword: value });
                                    }}
                                />
                            </div>
                        </div>
                    </Dialog>
                    <LogoutModal
                        open={confirmLogoutOpen}
                        onCancel={() => this.setState({ confirmLogoutOpen: false })}
                    />
                    <SnackBar {...snackbarConfig} />
                </Toolbar >
            </div >
        );
    }
}

const mapStateToProps = ({ userData, userData: { permissions }, globalData }) => {
    return {
        userData,
        globalData
    };
};

export default connect(mapStateToProps, { ...actions })(CustomToolbar);



// WEBPACK FOOTER //
// ./components/layout/toolbar.js